var render, staticRenderFns
import script from "./DragAndDropDraggable.vue?vue&type=script&lang=js&"
export * from "./DragAndDropDraggable.vue?vue&type=script&lang=js&"
import style0 from "./DragAndDropDraggable.vue?vue&type=style&index=0&id=231e615a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231e615a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('231e615a')) {
      api.createRecord('231e615a', component.options)
    } else {
      api.reload('231e615a', component.options)
    }
    
  }
}
component.options.__file = "ScriptsV2/Core/Components/DragAndDrop/DragAndDropDraggable.vue"
export default component.exports